<template>
  <div>
    <van-nav-bar title="利润-公司纬度" left-text="返回" left-arrow @click-left="onClickLeft">
      <template #right>
        <van-icon name="wap-home-o" size="18" @click="toHome"/>
      </template>
    </van-nav-bar>
    <van-row style="margin-top: 2px; margin-bottom: 2px; padding-right: 13px;">
      <van-col span="4" style="display: flex; justify-content:center; align-items: center; padding-top: 12px; color: #646566;">
        时间:
      </van-col>
      <van-col span="20">
        <van-dropdown-menu>
          <van-dropdown-item v-model="dateOptionValue" :options="dateOptions" @change="onChangeDateOption"/>
        </van-dropdown-menu>
      </van-col>
    </van-row>
    <div class="van-address-list" type="primary" style="padding-bottom: 0; padding-top: 2px;">
      <div v-for="item in dataList" :key="item.id" :name="item.id">
        <div class="van-address-item" style="margin-bottom: 5px;">
          <div class="van-cell van-cell--borderless">
            <div class="van-cell__value van-cell__value--alone van-address-item__value">
              <div class="van-address-item__name">
                <span style="margin-right: 3px;">{{ item.keyword }}</span>
              </div>
              <div class="van-address-item__address">
                {{ item.factoryName }}
              </div>
              <div class="van-address-item__address">
                <el-link type="success">量:{{ item.number }}</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="success">额:{{ item.amount }}</el-link>
              </div>
              <div class="van-address-item__address">
                <el-link type="danger" v-if="item.returnNumber">退量:{{ item.returnNumber }}</el-link>
                <el-divider direction="vertical"  v-if="item.returnNumber"></el-divider>
                <el-link type="danger"  v-if="item.returnAmount">退额:{{ item.returnAmount }}</el-link>
              </div>
              <div class="van-address-item__address">
                <el-link type="danger">成本总额:{{item.costAmount + item.freightAmount}} ({{ item.costAmount }} + {{ item.freightAmount }})</el-link>
              </div>
              <div class="van-address-item__address">
                <el-link type="primary">净销售量:{{ item.number - item.returnNumber }}</el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link type="primary">净利润:{{ item.profit }}</el-link>
              </div>
            </div>
            <van-icon class="van-address-item__edit" name="more-o" size="25" @click="showFactoryInfoPopup(item)"/>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="isFactoryInfoPopShow" position="bottom" :style="{ height: '70%' }">
      <div class="van-address-list" style="padding-bottom: 0">
        <div v-for="item in factoryData.subList" :key="item.id" :name="item.id">
          <div class="van-address-item" style="margin-bottom: 5px;">
            <div class="van-cell van-cell--borderless">
              <div class="van-cell__value van-cell__value--alone van-address-item__value">
                <div class="van-address-item__name">
                  <span style="margin-right: 3px;">{{ item.keyword }}</span>
                </div>
                <div class="van-address-item__address">
                  {{ factoryData.factoryName }}
                </div>
                <div class="van-address-item__address">
                  <el-link type="success">量:{{ item.number }}</el-link>
                  <el-divider direction="vertical"></el-divider>
                  <el-link type="success">额:{{ item.amount }}</el-link>
                </div>
                <div class="van-address-item__address">
                  <el-link type="danger" v-if="item.returnNumber">退量:{{ item.returnNumber }}</el-link>
                  <el-divider direction="vertical"  v-if="item.returnNumber"></el-divider>
                  <el-link type="danger"  v-if="item.returnAmount">退额:{{ item.returnAmount }}</el-link>
                </div>
                <div class="van-address-item__address">
                  <el-link type="danger">成本总额:{{item.costAmount + item.freightAmount}} ({{ item.costAmount }} + {{ item.freightAmount }})</el-link>
                </div>
                <div class="van-address-item__address">
                  <el-link type="primary">净销售量:{{ item.number - item.returnNumber }}</el-link>
                  <el-divider direction="vertical"></el-divider>
                  <el-link type="primary">净利润:{{ item.profit }}</el-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  AddressList,
  Card,
  DropdownItem,
  DropdownMenu,
  List,
  Loading,
  NavBar,
  Notify,
  PullRefresh,
  Search,
  Switch,
  Tag
} from 'vant';

import * as analysisService from "@/api/admin/analysis";

export default {
  components: {
    [Tag.name]: Tag,
    [Card.name]: Card,
    [Search.name]: Search,
    [Loading.name]: Loading,
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Notify.name]: Notify,
    [AddressList.name]: AddressList,
    [NavBar.name]: NavBar,
    [Switch.name]: Switch,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  name: "ProductProfitFactory",
  data() {
    return {
      searchParam: {
        storeName: '',
        dateType: '0'
      },
      dataList: [],
      isFactoryInfoPopShow: false,
      factoryData: [],
      dateOptionValue: '0',
      dateOptions: [
        {text: '去年', value: '0'},
        {text: '今年', value: '1'},
        {text: '前年', value: '2'},
      ],
    };
  },
  created() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      let that = this;
      analysisService.getProductProfitFactory(this.searchParam).then(res => {
        if (res.status === 200) {
          that.dataList = res.data
        }
      })
    },
    onRefresh() {
      // 清空列表数据
      this.dataList = [];
      // 重新加载数据
      this.onLoad();
    },
    onSearch() {
      this.onRefresh()
    },
    onSearchClear() {
      this.searchParam.storeName = null
      this.onRefresh();
    },
    toHome() {
      this.$router.push({path: '/index'})
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    showFactoryInfoPopup(data) {
      this.factoryData = data
      this.isFactoryInfoPopShow = true
    },
    onChangeDateOption() {
      this.searchParam.dateType = this.dateOptionValue
      this.onRefresh()
      this.isSearchPopShow = false
    },
  },
};
</script>

<style lang="less">
.underline-link {
  text-decoration: underline;
}
</style>
